import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { PatientSelectorComponent } from '../../shared/components/patient-selector/patient-selector.component';
import { ManualPatientSelectorComponent } from '../../_dialogs/manual-patient-selector/manual-patient-selector.component';
import { Subject } from '../../_interfaces/subject';
import { EncounterService } from '../../_services/encounter.service';
import { APP_DIALOG_DATA } from '../../shared/components/dialog/dialog.tokens';
import { AppDialogRef } from '../../shared/components/dialog/dialog-ref';
import { DialogService } from '../../shared/components/dialog/dialog.service';

export interface UploadSelectPatientData {
  dictationId: string;
  fileName?: string;
}

export interface UploadSelectPatientResult {
  proceed: boolean;
}

@Component({
  selector: 'app-upload-select-patient',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule, PatientSelectorComponent, TranslateModule],
  templateUrl: './upload-select-patient.component.html'
})
export class UploadSelectPatientComponent {
  constructor(
    private dialogRef: AppDialogRef<UploadSelectPatientComponent, UploadSelectPatientResult>,
    private dialog: DialogService,
    @Inject(APP_DIALOG_DATA) public data: UploadSelectPatientData,
    private encounterService: EncounterService,
    private snackBar: MatSnackBar,
    private translate: TranslateService
  ) {}

  async onPatientSelected(patient: Subject | null): Promise<void> {
    if (!patient) return;

    if (!navigator.onLine) {
      this.snackBar.open(
        this.translate.instant('You are offline. Please check your internet connection and try again.'),
        this.translate.instant('Close'),
        {
          duration: 5000,
          horizontalPosition: 'right',
          verticalPosition: 'bottom'
        }
      );
      return;
    }

    await this.encounterService.updatePatient(this.data.dictationId, patient);
    this.dialogRef.close({ proceed: true });
  }

  continueWithoutPatient(): void {
    this.dialogRef.close({ proceed: true });
  }

  openManualPatient(): void {
    const childRef = this.dialog.open(ManualPatientSelectorComponent, {
      size: 'sm',
      data: { from: 'edit', dictationId: this.data.dictationId }
    });

    childRef.beforeClosed().subscribe((res) => {
      if (res === 'back') {
        return;
      }
      if (res === 'close') {
        this.dialogRef.dismiss('close' as unknown as UploadSelectPatientResult);
        return;
      }
      if (res) {
        this.dialogRef.dismiss({ proceed: true });
      }
    });
    childRef.afterClosed().subscribe((res) => {
      if (!res || res === 'back') {
        this.dialog.show(this.dialogRef);
      }
    });
  }

  close(): void {
    this.dialogRef.close();
  }
}
